export default class DpitColor {
	constructor(src) {

		if (src == null) { // eslint-disable-line no-eq-null,eqeqeq
			this.rgbObj = {
				r: 0,
				g: 0,
				b: 0
			};
		} else if (src instanceof DpitColor) {
			this.rgbObj = { ...src.rgbObj };
		} else if (typeof src === 'string') {
			if (src.startsWith('#')) {
				this.rgbObj = DpitColor.hexStringToRgbObj(src);
			} else {
				this.rgbObj = DpitColor.rgbStringToRgbObj(src);
				if (!this.rgbObj) {
					throw new Error('Argument "src" isn\'t valid');
				}
			}
		} else if (src) {
			this.rgbObj = { ...src };
		}
	}

	static getRgbStringCommaSeparated(colorDefinition) {
		if (colorDefinition) {
			try {
				const colorObj = new DpitColor(colorDefinition);
				return colorObj.toRgbStringCommaSeparated();
			}
			catch {
				return '';
			}
		}
	}

	static fromRgb(r, g, b) {
		return new DpitColor({ r, g, b });
	}

	static rgbStringToRgbObj(rgbString) {
		const regex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/;
		const match = rgbString.match(regex);
		if (match) {
			const r = parseInt(match[1], 10);
			const g = parseInt(match[2], 10);
			const b = parseInt(match[3], 10);
			return { r, g, b };
		}
		return null; // Invalid RGB string format
	}

	static hexStringToRgbObj(hex) {
		// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
		var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
		hex = hex.replace(shorthandRegex, function (m, r, g, b) {
			return r + r + g + g + b + b;
		});

		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result ? {
			r: parseInt(result[1], 16),
			g: parseInt(result[2], 16),
			b: parseInt(result[3], 16)
		} : null;
	}

	contrast(color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();

		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}

		return (lum2 + 0.05) / (lum1 + 0.05);
	}

	luminosity() {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var lum = {};
		Object.keys(this.rgbObj).forEach(key => {
			var chan = this.rgbObj[key] / 255;
			lum[key] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		});
		return 0.2126 * lum.r + 0.7152 * lum.g + 0.0722 * lum.b;
	}

	red() { return this.rgbObj.r; }
	green() { return this.rgbObj.g; }
	blue() { return this.rgbObj.b; }
	isDark() {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var yiq = (this.rgbObj.r * 299 + this.rgbObj.g * 587 + this.rgbObj.b * 114) / 1000;
		return yiq < 128;
	}

	isLight() {
		return !this.isDark();
	}

	mix(colorToMixIn, weight) {

		if (!(colorToMixIn instanceof DpitColor) || !colorToMixIn.rgbObj) {
			throw new Error('Argument "mixinColor" isn\'t a DpitColor instance, but rather an instance of ' + typeof colorToMixIn);
		}
		var color1 = colorToMixIn;
		var color2 = this;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var w1 = (w + 1) / 2.0;
		var w2 = 1 - w1;

		return DpitColor.fromRgb(
			Math.max(Math.min(255, Math.round(w1 * color1.red() + w2 * color2.red())), 1),
			Math.max(Math.min(255, Math.round(w1 * color1.green() + w2 * color2.green())), 1),
			Math.max(Math.min(255, Math.round(w1 * color1.blue() + w2 * color2.blue())), 1)
		);
	}

	toRgbStringCommaSeparated() {
		return `${this.red()}, ${this.green()}, ${this.blue()}`;
	}

	setAsCssVariable(varName, element = document.documentElement) {
		element.style.setProperty(varName, this.toRgbStringCommaSeparated());
	}

}
